import script from "./TvaBackgroundVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./TvaBackgroundVideo.vue?vue&type=script&setup=true&lang=js"

import "./TvaBackgroundVideo.vue?vue&type=style&index=0&id=33cf7c7d&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33cf7c7d"]])

export default __exports__